import { QUEUE_INCOMING, QUEUE_BEING_DELIVERED } from '../constants/status';

const orderTimeStatus = (ticketQueue, currentTime, eta, creationTime) => {
  const getAgeInSecs = () => {
    const ageMs = new Date(currentTime) - Date.parse(creationTime);

    return Math.max(0, Math.floor(ageMs / 1000));
  };

  const getSecsUntilEta = () => {
    const msUntilEta = new Date(eta) - new Date(currentTime);

    return Math.floor(msUntilEta / 1000);
  };

  const isDanger = () => {
    if (ticketQueue === QUEUE_INCOMING && getAgeInSecs() >= 30) {
      return true;
    }

    return ticketQueue === QUEUE_BEING_DELIVERED && getSecsUntilEta() < 60;
  };

  const isWarning = () => {
    const age = getAgeInSecs();

    if (ticketQueue === QUEUE_INCOMING && age >= 20 && age < 30) {
      return true;
    }

    const secsUntilEta = getSecsUntilEta();

    return ticketQueue === QUEUE_BEING_DELIVERED && secsUntilEta >= 60 && secsUntilEta < 120;
  };

  return {
    warning: isWarning(),
    danger: isDanger(),
  };
};

export default orderTimeStatus;



// WEBPACK FOOTER //
// ../utils/functions/order-time-status.js